const HTTP_PROTOCOL = /^http:\/\/|^\/\//;
const IMAGE_SIZE = /(\/)(-*\d+x-*\d+)(.\w+)$/;

export const DEFAULT_IMAGE =
    "https://assets.bwbx.io/images/users/iqjWHBFdfxIU/ixLUnOR.afP4/v0/-1x-1.jpg";

export default function sizeImage(url: string, width = -1, height = -1) {
    return url
        .replace(HTTP_PROTOCOL, "https://")
        .replace(IMAGE_SIZE, `$1${width}x${height}$3`);
}
